var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 14.9974H4.99992V16.6641H14.9999V3.33073H4.99992V4.9974H3.33325V2.4974C3.33325 2.03716 3.70635 1.66406 4.16659 1.66406H15.8333C16.2935 1.66406 16.6666 2.03716 16.6666 2.4974V17.4974C16.6666 17.9576 16.2935 18.3307 15.8333 18.3307H4.16659C3.70635 18.3307 3.33325 17.9576 3.33325 17.4974V14.9974ZM4.99992 9.16406H10.8333V10.8307H4.99992V13.3307L0.833252 9.9974L4.99992 6.66406V9.16406Z",
    fill: "#CC4525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.be878074d2f55526e1ff3834d7d838ba.svg";
export { ForwardRef as ReactComponent };